import { render, staticRenderFns } from "./MerchantPOS.vue?vue&type=template&id=0d87a635&"
import script from "./MerchantPOS.vue?vue&type=script&lang=js&"
export * from "./MerchantPOS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports